import React from 'react'

import { SkeletonStyles } from './styles'

const { base, rounded, small, large } = SkeletonStyles

interface SkeletonProps {
	width?: string
	height?: string
	borderRadius?: string
	variant?: 'base' | 'rounded' | 'small' | 'large'
	style?: React.CSSProperties
	className?: string
}

export const Skeleton = ({
	width = '100%',
	height = '16px',
	borderRadius = '4px',
	variant = 'base',
	style,
	className,
}: SkeletonProps) => {
	const variants: Record<string, string> = {
		base: base(),
		rounded: rounded(),
		small: small(),
		large: large(),
	}

	return (
		<div
			className={`${variants[variant]} ${className ?? ''}`}
			style={{
				width,
				height,
				borderRadius,
				...style,
			}}
		/>
	)
}
